import { FC } from "react";
import { Button } from "antd";
import _t from "../../../lang/translate";
import LeasingStore from "../../../contexts/leasingStore";
import CustomerDetails from "../customer/customerDetails";
import { isPrivateCustomer } from "../../../services/customerService";
import LeasingContactPersonsInfo from "./leasingContactPersonsInfo";
import CardBox from "../../../components/cardBox";

interface LeasingCustomerInfoProps {
  startEditing: () => void;
}

const LeasingCustomerInfo: FC<LeasingCustomerInfoProps> = ({ startEditing }) => {
  const { leasingCase, isAdmin } = LeasingStore.useContainer();
  const { flags } = leasingCase;
  const { validationStarted, readonly, inputLocked } = flags;
  const disabled = readonly || inputLocked;

  const isPrivate = isPrivateCustomer(leasingCase?.customer?.typeId);

  return (
    <>
      <CustomerDetails hideNote customer={leasingCase.customer} hideContactPersons hideCpr={!isAdmin} hidePBS={!isAdmin} />
      {!isPrivate && (
        <>
          <LeasingContactPersonsInfo contactPersonKey="legalOwner" />
          <LeasingContactPersonsInfo contactPersonKey="contactPerson" />
        </>
      )}

      {isAdmin && (
        <CardBox style={{ marginInline: -8, marginTop: 32, whiteSpace: "pre-wrap", minWidth: 0 }} title={_t("customer", "note")}>
          {leasingCase.customer?.note}
        </CardBox>
      )}
      {!validationStarted && (
        <div className="text-right">
          <Button type="link" className="pl-0 pr-0 mt-1" onClick={startEditing} disabled={disabled}>
            {_t("edit")}
          </Button>
        </div>
      )}

    </>
  );
};

export default LeasingCustomerInfo;
